import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/sign-in'
    },
    {
      path: '/license/:uid',
      name: 'license',
      props: true,
      component: () =>
        import('@/views/PageLicense')
    },
    {
      path: '/license/activation/:uid',
      name: 'license-activation',
      props: true,
      component: () =>
        import('@/views/PageLicenseActivation')
    },
    {
      path: '/profile/:uid',
      name: 'profile',
      props: true,
      component: () =>
        import('@/views/PageProfile')
    },
    {
      path: '/profile-edit',
      name: 'profile-edit',
      component: () =>
        import('@/views/PageProfileEdit')
    },
    {
      path: '/payment',
      name: 'payment',
      component: () =>
        import('@/views/PagePayment')
    },
    {
      path: '/settings',
      name: 'settings',
      props: true,
      component: () =>
        import('@/views/PageSettings')
    },
    {
      path: '/sign-in/:redirectPath?',
      name: 'sign-in',
      props: true,
      component: () =>
        import('@/views/PageSignIn')
    },
    {
      path: '/sign-up/:oneTimePassword?/:redirectPath?',
      name: 'sign-up',
      props: true,
      component: () =>
        import('@/views/PageSignIn')
    },
    // for public page
    {
      path: '/search',
      name: 'search',
      component: () =>
        import('@/views/PageSearch')
    },
    {
      path: '/catalyst/:uid',
      name: 'catalyst',
      props: true,
      component: () =>
        import('@/views/PageCatalyst')
    }
  ]
})
